
/**
 * @file   src\components\GenerateLink.tsx
 * @brief Generate app URL component.
 * @date   AUGUST, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { React, Button, useState, Modal } from '../utils/thirdpartyComponents';
import '../components/CWModal.scss';
import { MessageToaster } from "../utils/toastUtil";
import axios from '../config/axiosConfig';
import SmallLoader from '../components/SmallLoader';
import { CompanyApi } from '../utils/apiUrls';


const CarWashStatus = (props: any) => {
    // State to handle generated link
    const toaster = new MessageToaster();
    const [loading, setLoading] = useState(false);

    // pause location functions
    const [selected_company, setSelected_company] = useState(0);
    const [selected_company_status, setSelected_company_status] = useState<boolean>(false);
    const [showCompanyStatuspoup, setShowCompanyStatuspoup] = useState<boolean>(false);
    const statuschangebuttonClick = () => {
        setSelected_company(props.companyName);
        setSelected_company_status(props.status === false ? true : false);
        setShowCompanyStatuspoup(true);
    }
    //Hide ppopup
    const hideshowCompanyStatuspoupModal = () => {
        setShowCompanyStatuspoup(false);
    }
    const DeactivateCarWash = async () => {
        try {
            setLoading(true); // Show loader
            const CompanyStatusRequest = {
                carWashId: parseInt(props.carWashId),
                status: selected_company_status
            };
            const  responseCompanyStatus =await axios.post(CompanyApi.UPDATE_COMPANY_STATUS, CompanyStatusRequest);
            if ( responseCompanyStatus?.data?.error === 0) {
                toaster.toastSuccess( responseCompanyStatus?.data?.message);
                setShowCompanyStatuspoup(false);
                window.location.reload();
                //setShowCompanyStatuspoup(false);
            }
            else {
                setShowCompanyStatuspoup(false);
                setShowCompanyStatuspoup(false);
                toaster.toastError( responseCompanyStatus?.data?.message);
            }

        } catch (error: any) {
            toaster.toastError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
        }
    }

    return (
        <>
            <div className="stat-group d-flex align-items-center">
                {props.status ? (
                    <Button
                        title="Deactivate"
                        type="button"
                        variant="primary"
                        className="action-btn deactive"
                        onClick={() => statuschangebuttonClick()}
                    >
                        Deactivate Car Wash
                    </Button>
                ) : (
                    <Button
                        title="Activate"
                        type="button"
                        variant="secondary"
                        className="action-btn active"
                        onClick={() => statuschangebuttonClick()}
                    >
                        Activate Car Wash
                    </Button>
                )}
            </div>
            {loading && <SmallLoader />}

            <Modal
                show={showCompanyStatuspoup}
                onHide={hideshowCompanyStatuspoupModal}
                centered
                className='add-modal'
            >
                <Modal.Body className='text-center'>
                    <h5 className='f-bold text-center'>Do you want to {props.status ? 'Deactivate' : 'Activate'} the company {selected_company}?</h5>
                    <div className="btn-sec d-grid">
                        <Button title='Not Now' variant="light" className="secondary-btn" onClick={hideshowCompanyStatuspoupModal}>Not Now</Button>
                        <Button title='Yes' variant="primary" className='primary-btn btn-main m-0' onClick={DeactivateCarWash}>Yes</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default CarWashStatus;



